import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Calendar, AlertTriangle } from "lucide-react";

const cls = (u) => u === "past" ? "text-[#B35D4C] border-[#B35D4C]/30 bg-[#B35D4C]/[0.04]"
 : u === "soon" ? "text-[#0D2B52] border-[#1B6C62]/40 bg-[#E6F5F2]/40"
 : "text-[#6B7280] border-[#E5E4DE]";

export default function DeadlinesWidget({ caseId }) {
 const [data, setData] = useState({ now: "", deadlines: [] });

 useEffect(() => {
 api.get(`/cases/${caseId}/deadlines`).then(({ data }) => setData(data));
 }, [caseId]);

 if (!data.deadlines || data.deadlines.length === 0) {
 return (
 <div className="card" data-testid="deadlines-widget">
 <div className="flex items-center gap-2 mb-2">
 <Calendar size={16} strokeWidth={1.5} className="text-[#1B6C62]" />
 <h4 className="font-serif text-lg text-[#0D2B52]">Key dates</h4>
 </div>
 <p className="text-sm text-[#6B7280] italic">Add lease start/end dates to see your deadlines.</p>
 </div>
 );
 }

 return (
 <div className="card" data-testid="deadlines-widget">
 <div className="flex items-center justify-between mb-3">
 <div className="flex items-center gap-2">
 <Calendar size={16} strokeWidth={1.5} className="text-[#1B6C62]" />
 <h4 className="font-serif text-lg text-[#0D2B52]">Key dates</h4>
 </div>
 <span className="label-mono">{data.now}</span>
 </div>
 <ul className="space-y-2">
 {data.deadlines.map((d, i) => (
 <li key={i} className={`flex items-center justify-between border-l-2 pl-3 py-1.5 text-sm ${cls(d.urgency)}`} data-testid={`deadline-${i}`}>
 <div className="min-w-0">
 <div className="font-medium truncate">{d.label}</div>
 {d.note && <div className="text-xs text-[#6B7280] truncate">{d.note}</div>}
 </div>
 <div className="text-right flex-shrink-0 ml-3">
 <div className="font-mono text-xs">{d.date}</div>
 <div className="text-[10px] uppercase tracking-wider">
 {d.days === 0 ? "today" : d.days > 0 ? `in ${d.days} day${d.days === 1 ? "" : "s"}` : `${-d.days} day${d.days === -1 ? "" : "s"} ago`}
 </div>
 </div>
 </li>
 ))}
 </ul>
 </div>
 );
}
